import { Box, Typography } from "@mui/material";
import abosLogoClean from "../assets/brand/abos-logo-clean.png";

export default function AppLogo({ compact = false, light = false }) {
  const logoSize = compact ? 38 : 46;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: compact ? 1 : 1.25, minWidth: 0 }}>
      <Box
        sx={{
          width: logoSize,
          height: logoSize,
          display: "grid",
          placeItems: "center",
          overflow: "hidden",
          borderRadius: compact ? 2.2 : 2.6,
          bgcolor: "#000",
          border: light
            ? "1px solid rgba(94, 234, 212, 0.16)"
            : "1px solid rgba(37, 99, 235, 0.12)",
          boxShadow: light
            ? "0 12px 28px rgba(14, 165, 233, 0.16)"
            : "0 12px 28px rgba(37, 99, 235, 0.14)",
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={abosLogoClean}
          alt="ABOS"
          sx={{
            display: "block",
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      {!compact && (
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            noWrap
            sx={{
              color: light ? "white" : "text.primary",
              fontWeight: 950,
              fontSize: "1.38rem",
              letterSpacing: ".03em",
              lineHeight: 1.02,
            }}
          >
            ABOS
          </Typography>
          <Typography
            variant="caption"
            noWrap
            display="block"
            sx={{
              color: light ? "#5eead4" : "#0f766e",
              mt: 0.32,
              fontWeight: 800,
              letterSpacing: ".055em",
              fontSize: compact ? 9 : 10,
            }}
          >
            AI BUSINESS OPERATING SYSTEM
          </Typography>
        </Box>
      )}
    </Box>
  );
}
